import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { Button, TextField } from '@material-ui/core';

import './App.scss';

const LoginSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email address').required('Required'),
  password: Yup.string().required('Required')
});

const handleSubmit = (values, { setSubmitting }) => {
  sessionStorage.removeItem('user_token')
  setTimeout(() => {
    if (values.email === 'mmcdharan@gmail.com' && values.password === 'password') {
      sessionStorage.setItem('user_token', btoa('abQfnejDI3nnF9OM0Czs|mmcdharan'))
      window.location.reload()
    } else {
      alert('UnAuthorized Access')
    }
    setSubmitting(false);
  }, 200);
}

const Login = () => {

  return (
    <div className="login-container">

      <h1>Login</h1>

      <div className="login-box">
        <Formik
          initialValues={{ email: '', password: '' }}
          validationSchema={LoginSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit}>
              <TextField
                name="email" type="email" margin="dense" label="Email Address" fullWidth
                onChange={handleChange}
                onBlur={handleBlur}
                InputLabelProps={{ shrink: true, required: true }}
                value={values.email} required
                helperText={errors.email && touched.email && errors.email}
                error={errors.email && touched.email}
              />
            
              <div>&nbsp;</div>

              <TextField
                name="password" type="password" margin="dense" label="Password" fullWidth
                onChange={handleChange}
                onBlur={handleBlur}
                InputLabelProps={{ shrink: true, required: true }}
                value={values.password} required
                helperText={errors.password && touched.password && errors.password}
                error={errors.email && touched.email}
              />
          
              <div>&nbsp;</div>
            
              {/* <button type="submit" disabled={isSubmitting}>
              Submit
            </button> */}
              <Button type="submit" variant="contained" color="primary" size="medium" disabled={isSubmitting} fullWidth>
                {isSubmitting ? 'Please Wait' : 'Login'}
              </Button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default Login;